<div class="membership-customer-widget-container">
    <p-progressbar *ngIf="loadingStates.page" mode="indeterminate" [style]="{'height': '6px'}" />

    <p-card *ngIf="!loadingStates.page" class="membership-card">
            <p-message *ngIf="messages" [severity]="messages.severity" [text]="messages.summary" [closable]="false" styleClass="w-full mb-3" />
        <p-tabView>
            <!-- Membership Signup Tab -->
            <p-tabPanel header="Sign Up for Membership">
                <p-stepper [value]="1">
                    <p-step-item [value]="1">
                        <p-step>Membership Plan</p-step>
                        <p-step-panel header="Membership Plan">
                            <ng-template pTemplate="content" let-activateCallback="activateCallback" let-index="index">
                                <div class="grid">
                                    <div class="col-12">
                                        <label for="membership-plan-dropdown">Select Membership Plan</label>
                                        <p-select [options]="membershipPlans" [(ngModel)]="selectedMembershipPlan"
                                            optionLabel="name" placeholder="Choose a membership plan"
                                            [loading]="loadingStates.membershipPlans" styleClass="w-full" inputId="membership-plan-dropdown">
                                            <ng-template let-plan pTemplate="item">
                                                <div class="flex align-items-center justify-content-between w-100">
                                                    <div class="flex-grow-1">
                                                        <div class="font-bold">{{plan.name}}</div>
                                                        <div class="text-muted small">{{plan.description}}</div>
                                                        <div class="text-muted small">Billed every {{plan.billingInterval}}</div>
                                                    </div>
                                                    <div class="text-right">
                                                        <div class="font-bold">${{plan.price}}</div>
                                                    </div>
                                                </div>
                                            </ng-template>
                                        </p-select>
                                    </div>
                                    <div *ngIf="selectedMembershipPlan" class="col-12">
                                        <div class="selected-plan-details">
                                            <h3>Selected Plan: {{selectedMembershipPlan.name}}</h3>
                                            <p>{{selectedMembershipPlan.description}}</p>
                                            <div class="plan-features">
                                                <div class="feature">
                                                    <i class="pi pi-dollar"></i>
                                                    <span>Price: ${{selectedMembershipPlan.price}}</span>
                                                </div>
                                                <div class="feature">
                                                    <i class="pi pi-calendar"></i>
                                                    <span>Billing: {{selectedMembershipPlan.billingInterval}}</span>
                                                </div>
                                                <div class="feature">
                                                    <i class="pi pi-ticket"></i>
                                                    <span>Max Bookings: 
                                                        <ng-content *ngIf="selectedMembershipPlan.maxBookingsPerMonth > 0">{{selectedMembershipPlan.maxBookingsPerMonth}}</ng-content>
                                                        <ng-content *ngIf="selectedMembershipPlan.maxBookingsPerMonth === 0">Unlimited</ng-content>
                                                    </span>
                                                </div>
                                                <div *ngIf="selectedMembershipPlan.discountPercent > 0" class="feature">
                                                    <i class="pi pi-percentage"></i>
                                                    <span>Discount: {{selectedMembershipPlan.discountPercent}}% off bookings</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div class="d-flex justify-content-end">
                                            <p-button label="Next" icon="pi pi-arrow-right" iconPos="right"
                                                (onClick)="activateCallback(2); this.messages = null;"
                                                [disabled]="!isValid([selectedMembershipPlan])">
                                            </p-button>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </p-step-panel>
                    </p-step-item>
                    <p-step-item [value]="2">
                        <p-step>Personal Information</p-step>
                        <p-step-panel header="Personal Information">
                            <ng-template pTemplate="content" let-activateCallback="activateCallback" let-index="index">
                                <div class="container">
                                    <div class="row mb-1">
                                        <div class="col-12 md:col-6">
                                            <label for="first-name">First Name</label>
                                            <input pInputText [(ngModel)]="membershipForm.firstName" id="first-name"
                                                placeholder="Enter your first name" class="full-width" required />
                                        </div>
                                        <div class="col-12 md:col-6">
                                            <label for="last-name">Last Name</label>
                                            <input pInputText [(ngModel)]="membershipForm.lastName" id="last-name"
                                                placeholder="Enter your last name" class="full-width" required />
                                        </div>
                                    </div>
                                    <div class="row mb-1">
                                        <div class="col-12">
                                            <label for="email">Email Address</label>
                                            <input pInputText [(ngModel)]="membershipForm.emailAddress" type="email" id="email"
                                                placeholder="Enter your email address" class="full-width" required />
                                        </div>
                                    </div>
                                    <div class="row mt-1">
                                        <div class="col-12 d-flex justify-content-between">
                                            <p-button label="Back" icon="pi pi-arrow-left" (onClick)="activateCallback(1)" />
                                            <p-button label="Next" icon="pi pi-arrow-right" iconPos="right"
                                                (onClick)="handleNext(activateCallback, 3)"
                                                [disabled]="!isValid([membershipForm.firstName, membershipForm.lastName, membershipForm.emailAddress]) || loadingStates.payment"
                                                [loading]="loadingStates.payment">
                                            </p-button>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </p-step-panel>
                    </p-step-item>
                    <p-step-item [value]="3">
                        <p-step>Payment</p-step>
                        <p-step-panel header="Payment">
                            <ng-template pTemplate="content" let-activateCallback="activateCallback" let-index="index">
                                <div class="row">
                                    <p-progressBar *ngIf="loadingStates.payment" mode="indeterminate" [style]="{'height': '6px'}" />
                                </div>
                                <div class="row mb-3">
                                    <div class="col-12">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <span class="font-bold">Total Amount:</span>
                                            <span class="font-bold">${{selectedMembershipPlan.price.toFixed(2)}} / {{selectedMembershipPlan.billingInterval}}</span>
                                        </div>
                                        <div class="text-success mt-1">
                                            <small>Membership plan: {{selectedMembershipPlan?.name}}</small>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12">
                                        <ngx-stripe-elements [stripe]="stripe" [elementsOptions]="elementsOptions">
                                            <ngx-stripe-card [options]="cardOptions" (change)="onCardChange($event)" />
                                        </ngx-stripe-elements>
                                    </div>
                                </div>
                                <div class="row mt-1">
                                    <div class="col-12 d-flex justify-content-between">
                                        <p-button label="Back" icon="pi pi-arrow-left" (onClick)="activateCallback(2)" />
                                        <p-button label="Complete Membership" icon="pi pi-check" iconPos="right"
                                            [loading]="loadingStates.submission" [disabled]="loadingStates.submission || !isValid([selectedMembershipPlan]) || !isCardValid"
                                            (onClick)="submit()" />
                                    </div>
                                </div>
                            </ng-template>
                        </p-step-panel>
                    </p-step-item>
                </p-stepper>
            </p-tabPanel>

            <!-- Manage Account Tab -->
            <p-tabPanel header="Manage My Account">
                <div class="container">
                    <div class="row mb-3">
                        <div class="col-12">
                            <h3>Get Session Link</h3>
                            <p class="text-muted">Enter your email address to receive a secure link to manage your membership account.</p>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-12">
                            <label for="manage-email">Email Address</label>
                            <input pInputText [(ngModel)]="manageAccountEmail" type="email" id="manage-email"
                                placeholder="Enter your email address" class="full-width" required />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <p-button label="Send Session Link" icon="pi pi-envelope" 
                                (onClick)="sendSessionLink()" 
                                [loading]="loadingStates.sessionLink"
                                [disabled]="!manageAccountEmail || loadingStates.sessionLink"
                                class="w-100">
                            </p-button>
                        </div>
                    </div>
                    <div *ngIf="sessionLinkSent" class="row mt-3">
                        <div class="col-12">
                            <div class="alert alert-success">
                                <i class="pi pi-check-circle"></i>
                                <span>A secure session link has been sent to your email address. Please check your inbox and spam folder.</span>
                            </div>
                        </div>
                    </div>
                </div>
            </p-tabPanel>
        </p-tabView>
    </p-card>
</div>
